import { render } from "./LogoutIcon.vue?vue&type=template&id=5e6052c6&bindings={}"
import script from "./LogoutIcon.vue?vue&type=script&lang=ts"
export * from "./LogoutIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script